import React from 'react'

import { Redirect, withRouter } from 'react-router'

// Выполняет переход, который попросило приложение (store.redirect). Пока он не сделан, Root
// держит этот компонент рядом с роутами. redirectTo: строка (заменить запись истории) или
// { to, push, state, back }, см. redirectTo в Root/actions.
class CustomRedirectionView extends React.Component {
    // Нужно ли вернуться назад: на экран открыли с метки back, значит прежний экран в истории есть.
    goesBack () {
        const { redirectTo, location } = this.props
        return Boolean(redirectTo.back && location.state && location.state[redirectTo.back])
    }
    componentDidMount () {
        if (typeof this.props.redirectTo === 'object' && this.goesBack()) {
            this.props.history.goBack()
        }
    }
    componentDidUpdate (){
        this.props.reset()
    }
    render () {
        const { redirectTo } = this.props
        if (typeof redirectTo === 'string') {
            return <Redirect to={redirectTo} />
        }
        if (this.goesBack()) {
            return null
        }
        // Адрес вида '/companypage?id=5' и метка в state: роутер хранит их отдельно.
        const [pathname, query] = redirectTo.to.split('?')
        const to = redirectTo.state
            ? { pathname, search: query ? `?${query}` : '', state: redirectTo.state }
            : redirectTo.to
        return <Redirect push={Boolean(redirectTo.push)} to={to} />
    }
}

export const CustomRedirection = withRouter(CustomRedirectionView)
